<template>
  <div class="border">
    <v-row align="center" class="pa-4">
      <v-card-title>Журнал открытия с распознавания ГРЗ</v-card-title>
      <div class="ml-2">
        <BaseTextField
          v-model="filterNumberCar"
          :is-button="false"
          :allow-only-latin="true"
          label="Номер автомобиля"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="roleName !== 'call-center'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="downloadReportPage"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
          </v-btn>
        </template>
        <span>Скачать отчёт на странице</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer mt-1 mb-2"
            v-bind="attrs"
            v-on="on"
            @click="updateInfo"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-col cols="12" sm="7" md="8" lg="7" class="py-0 mb-6">
      <v-row class="" style="">
        <v-menu
          v-model="menuFilterDate"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="230px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeFilter"
              label="Промежуток времени"
              outlined
              dense
              hide-details
              style="max-width: 360px;"
              class="input input-search mr-2 pl-3"
              v-on="on"
              prepend-inner-icon="mdi-calendar"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker v-model="dateFilter" @click="menuFilterDate = false" range :max="today">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Назад
            </v-btn>
            <v-btn text color="primary" :disabled="!dateFilter[0]" @click="dateFilter = []">
              Сбросить
            </v-btn>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Выбрать
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-btn
          :disabled="!dateFilter[1]"
          :style="isMobile ? 'margin-top: 10px;' : ''"
          @click="loadJournalGrz"
          class="btn primary white px-7 text-none ml-4"
        >
          Поиск
        </v-btn>
      </v-row>
    </v-col>
    <v-data-table
      class="table"
      :headers="HeadersJournal"
      :items="filtered"
      :loading="loadingList"
      :footer-props="{
        'items-per-page-options': [10, 15, 20, 50, 100, -1],
        showFirstLastPage: true
      }"
    >
      <template v-slot:item.action="{ item }">
        <v-btn color="primary" @click="loadImage(item.date)">
          Фотография
        </v-btn>
      </template>
      <template v-slot:item.date="{ item }">
        {{ ruDateFormat(item.date.replace(/([-+]\d+)$/, ''), false, true) }}
      </template>
      <template v-slot:item.opening_info="{ item }">
        <div v-if="item.opening_info === '-\r'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                width="18"
                height="18"
              >
                <v-icon x-small color="red">mdi-checkbox-blank-circle</v-icon>
              </v-btn>
            </template>
            <span>Номер был распознан, но его нет в базе данных.</span>
          </v-tooltip>
        </div>
        <div v-if="item.opening_info === '+\r'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                width="18"
                height="18"
              >
                <v-icon x-small color="green">mdi-checkbox-blank-circle</v-icon>
              </v-btn>
            </template>
            <span>Номер был распознан и находится в нашей базе данных.</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" :max-width="isMobile ? '90%' : '50%'" @input="dialog = false">
      <zoom-photo
        v-model="dialog"
        :photo="imageSrc"
        @closeZoomPhoto="dialog = false"
      >
      </zoom-photo>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import BaseTextField from '../../../BaseTextField';
import zoomPhoto from '../../../client/DetailClient/components/zoomPhoto';
import cp1251Encode from '@/mixins/cp1251Encode';

export default {
  name: 'JournalGrz',
  components: { BaseTextField, zoomPhoto },
  props: ['id'],
  mixins: [ruDateFormatMixin, cp1251Encode],
  data () {
    return {
      today: new Date().toISOString().split('T')[0],
      menuFilterDate: false,
      dateFilter: [],
      filterNumberCar: '',
      dialog: false,
      base64Image: '',
      startDate: '',
      endDate: '',
      sort: '',
      responseJournal: [],
      menu: false,
      isMobile: false,
      loadingList: false,
      selectedDate: null,
      HeadersJournal: [
        { text: 'Дата и время', value: 'date', align: 'center' },
        { text: 'Номер автомобиля', value: 'car_number', sortable: false, align: 'center' },
        { text: 'Распознание грз', value: 'opening_info', sortable: false, align: 'center' },
        { text: '', value: 'action', sortable: false, width: '8%', align: 'center' },
      ],
    };
  },
  created () {
    this.loadJournalGrz();
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
    if (this.dateFilter.length === 0) {
      const today = new Date().toISOString().split('T')[0];
      this.dateFilter = [today, today];
    }
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    filtered () {
      if (this.filterNumberCar) {
        return this.responseJournal.data.filter(item => {
          return item.car_number !== null &&
            String(item.car_number).toLowerCase().includes(this.filterNumberCar.toLowerCase());
        });
      } else {
        return this.responseJournal.data;
      }
    },
    imageSrc () {
      return `data:image/jpeg;base64,${this.base64Image}`;
    },
    dateRangeFilter () {
      let formattedStartDate = '';
      let formattedEndDate = '';
      if (this.dateFilter[0]) {
        formattedStartDate = this.ruDateFormat(this.dateFilter[0], true);
      }
      if (this.dateFilter[1]) {
        formattedEndDate = ` - ${this.ruDateFormat(this.dateFilter[1], true)}`;
      }

      return `${formattedStartDate}${formattedEndDate}`;
    },
  },
  methods: {
    ...mapActions({
      getJournalGrzOpen: 'Barriers/getJournalGrzOpen',
      getImageJournalGrz: 'Barriers/getImageJournalGrz',
    }),
    downloadReportPage () {
      const lines = [];
      this.filtered.forEach((item) => {
        const createdAt = this.ruDateFormat(item.date);
        let openingInfo;
        if (item.opening_info === '-\r') {
          openingInfo = '-';
        } else {
          openingInfo = 'Успешно';
        }
        const line = [
          createdAt, item.car_number, openingInfo,
        ].join(';');
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'Journal-grz.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async updateInfo () {
      await this.loadJournalGrz()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    loadImage (dateTime) {
      let formattedDateTime = dateTime;
      if (typeof dateTime === 'string') {
        // Обрезаем всё после секунд
        const match = dateTime.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/);
        if (match) {
          formattedDateTime = match[0];
        }
      }
      this.getImageJournalGrz({
        id: this.$route.params.id,
        dateTime: formattedDateTime,
      })
        .then((data) => {
          this.base64Image = data.data;
          this.dialog = true;
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Не удалось получить изображение журнал грз.');
        });
    },
    async loadJournalGrz () {
      // если дата не указана то автоматически подставляется текущий день
      if (this.dateFilter[1]) {
        this.startDate = this.dateFilter[0] + ' 00:00:00';
        this.endDate = this.dateFilter[1] + ' 23:59:59';
      }
      this.loadingList = true;
      await this.getJournalGrzOpen({
        id: this.$route.params.id,
        startDate: this.startDate,
        endDate: this.endDate,
        sort: this.sort,
      })
        .then((data) => {
          this.responseJournal = data.data;
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Не удалось получить журнал грз. Нет записей.');
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-footer {
  border-radius: 16px;
  background-color: #4C6C93;
  color: white;
  width: 65px !important;
  margin-right: 15px;
  height: 65px !important;
  padding: 5px 16px;
}
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
